import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Locale defaults agreed in memory.md Q6. Storage is always UTC. */
export const LOCALE = "en-IN";
export const TIMEZONE = "Asia/Kolkata";

export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat(LOCALE, {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: TIMEZONE,
  }).format(new Date(iso));
}

/** Date only (no time) — for joining date, DOB, and other plain-date fields.
 * Accepts an ISO date ("2020-06-01") or datetime; rendered in the app locale. */
export function formatDate(iso: string): string {
  // A bare "YYYY-MM-DD" is parsed as UTC midnight; format it in UTC so it does
  // not shift a day backwards in IST.
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(iso);
  return new Intl.DateTimeFormat(LOCALE, {
    dateStyle: "medium",
    timeZone: dateOnly ? "UTC" : TIMEZONE,
  }).format(new Date(iso));
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat(LOCALE, {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(amount);
}

/** "2h 15m left" / "3h 40m overdue" — used by every SLA surface. */
export function formatSlaRemaining(dueIso: string, now: Date = new Date()): string {
  const diffMs = new Date(dueIso).getTime() - now.getTime();
  const overdue = diffMs < 0;
  const mins = Math.floor(Math.abs(diffMs) / 60000);
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  const label = h > 0 ? `${h}h ${m}m` : `${m}m`;
  return overdue ? `${label} overdue` : `${label} left`;
}
